import type { RouteRecordRaw } from 'vue-router';
import { FEATURE_FLAGS, ROLES, SETTINGS_HOME_ACCESS_PERMISSIONS } from '@AuthModule';

// NOTE :: Only real, migrated settings pages get a route here. Every other settings link leaves for the
// legacy settings page — the one list in the api (config/settings_navigation.php) decides which is which.
// When a page is migrated, add its route with its permission meta AND set its app_path in that list.
export default <RouteRecordRaw[]>[
  {
    path: 'settings',
    meta: { isSettings: true },
    children: [
      {
        path: '',
        name: 'settings-home',
        component: () => import('./views/SettingsHome.view.vue'),
        meta: {
          permissions: SETTINGS_HOME_ACCESS_PERMISSIONS,
        },
      },
      {
        path: 'integration/petco-love-lost',
        name: 'settings-integration-petco-love-lost',
        component: () => import('./views/Integration/SettingsIntegrationPetcoLoveLost.view.vue'),
        meta: {
          permissions: [ROLES.INTEGRATIONS],
        },
      },
      {
        path: 'outcome/adoption-contracts',
        redirect: { name: 'settings-outcome-contracts', params: { outcomeType: 'adopted' } },
      },
      {
        path: 'outcome/contracts/:outcomeType(adopted|return_to_owner|transfer_out)',
        name: 'settings-outcome-contracts',
        component: () => import('./views/Outcome/SettingsOutcomeContracts.view.vue'),
        meta: {
          permissions: [ROLES.OUTCOME_SETTINGS],
        },
      },
      {
        path: 'medical/surgery-forms',
        name: 'settings-medical-surgery-forms',
        component: () => import('./views/Medical/SettingsMedicalSurgeryForms.view.vue'),
        meta: {
          featureFlag: FEATURE_FLAGS.SURGERY_PRINT_FORMS,
          permissions: [ROLES.MEDICAL_SETTINGS],
        },
      },
      {
        // NOTE :: Super-admin sessions only in this release; the view gates on isSU / isSUGLO and the api 403s
        // everyone else. The `website-settings` / `website-publish` permission slugs replace that gate next.
        path: 'website',
        name: 'settings-website',
        component: () => import('./views/Website/SettingsWebsite.view.vue'),
        meta: {
          featureFlag: FEATURE_FLAGS.WEBSITES,
          permissions: SETTINGS_HOME_ACCESS_PERMISSIONS,
        },
      },
    ],
  },
  // NOTE :: Settings used to live at /settings. Links already out there (legacy sidebar, bookmarks) keep working.
  {
    path: '/settings/:pathMatch(.*)*',
    redirect: (to) => `/shelter/settings/${[to.params.pathMatch ?? []].flat().join('/')}`,
  },
];
